/*
 * @Author: ycm-windows hesion3d@hesion3d.com
 * @Date: 2021-04-15 18:24:37
 * @LastEditors: ycm-windows hesion3d@hesion3d.com
 * @LastEditTime: 2022-10-27 17:25:17
 * @FilePath: \logoup_portal\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/home';
import Competition from '@/components/competition';
import Course from '@/components/course';
import About from '@/components/about';
import Download from '@/components/download';
import subject1 from '@/components/subject1';
import Gymnasium from '@/components/gymnasium';
import GymnasiumDetail from '@/components/gymnasiumDetail';
import Message from '@/components/message';
// import EntryForm from '@/components/entryForm';
// import QueryForm from '@/components/queryForm';
// import EntryFormFinal from '@/components/entryFormFinal';
// import QueryFormFinal from '@/components/queryFormFinal';
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home',
    }, {
      path: '/home',
      name: 'home',
      component: Home,
    }, {
      path: '/competition',
      name: 'competition',
      component: Competition,
    },
    {
      path: '/subject1',
      name: 'subject1',
      component: subject1,
    },
    
    {
      path: '/course',
      name: 'course',
      component: Course,
    }, {
      path: '/about',
      name: 'about',
      component: About,
    }, 
    {
      path: '/gymnasium',
      name: 'gymnasium',
      component: Gymnasium,
    },  {
      path: '/gymnasiumDetail',
      name: 'gymnasiumDetail',
      component: GymnasiumDetail,
    },    {
      path: '/message',
      name: 'message',
      component: Message,
    },
    // {
    //   path: '/entryForm',
    //   name: 'entryForm',
    //   component: EntryForm,
    // },
    // {
    //   path: '/queryForm',
    //   name: 'queryForm',
    //   component: QueryForm,
    // },
    // {
    //   path: '/entryFormFinal',
    //   name: 'entryFormFinal',
    //   component: EntryFormFinal,
    // },
    // {
    //   path: '/queryFormFinal',
    //   name: 'queryFormFinal',
    //   component: QueryFormFinal,
    // },
    {
      path: '/download',
      name: 'download',
      component: Download,
    }, {
      path: '/download/:source',
      name: 'h',
      component: Home,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js